"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchLocationDropdown = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _map = _interopRequireDefault(require("lodash/map"));
var _dropdownNavigationHoc = _interopRequireDefault(require("../dropdown-navigation-hoc"));
var _reactIntl = require("react-intl");
var _excluded = ["locations", "intl"],
  _excluded2 = ["whichDropdown"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ListContainer = function ListContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("ul", {
    tabIndex: "-1",
    role: "listbox",
    className: "dropdown-list",
    "aria-labelledby": null,
    style: {
      minWidth: '220px',
      margin: '0 -1px'
    }
  }, children);
};
var ErrorDropdown = function ErrorDropdown(_ref2) {
  var toggleModal = _ref2.toggleModal,
    listToggle = _ref2.listToggle;
  return /*#__PURE__*/_react.default.createElement(ListContainer, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '16px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "search.location_error_dropdown.dont_recognize",
    defaultMessage: "We don't recognize that location"
  }))));
};
var EmailDropdown = function EmailDropdown(_ref3) {
  var metros = _ref3.metros,
    toggleModal = _ref3.toggleModal,
    listToggle = _ref3.listToggle;
  return /*#__PURE__*/_react.default.createElement(ListContainer, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '16px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "search.location_email_dropdown.is_not_there",
    defaultMessage: "Peerspace is not there yet but we're live in"
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "btn-link remove-click-styling no-gutter",
    onClick: function onClick(e) {
      toggleModal(e, listToggle);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "search.location_email_dropdown.check_them_out",
    defaultMessage: "{length} cities, check them out.",
    values: {
      length: metros.length
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '0 16px 16px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "search.location_email_dropdown.adding_unique_spaces",
    defaultMessage: "We're adding unique spaces in cities all over the world. {link} and you'll be the first one to know.",
    values: {
      link: /*#__PURE__*/_react.default.createElement("a", {
        href: "http://try.peerspace.com/global/"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "search.location_email_dropdown.leave_email",
        defaultMessage: "Leave your email"
      }))
    }
  })));
};
var LocationList = (0, _dropdownNavigationHoc.default)(function (_ref4) {
  var data = _ref4.data,
    clickPoi = _ref4.clickPoi,
    listToggle = _ref4.listToggle,
    index = _ref4.index,
    onKeyDownList = _ref4.onKeyDownList;
  var description = data.description,
    placeId = data.place_id,
    matchedSubstring = data.matched_substrings;
  var end = 0;
  for (var i = 0; i < matchedSubstring.length; i++) {
    if (0 === i) {
      end = matchedSubstring[i].length;
    }
    end = matchedSubstring[i].offset + matchedSubstring[i].length;
  }
  var boldLetters = description.substring(0, end);
  var remainingLetters = description.substring(boldLetters.length, description.length);
  return /*#__PURE__*/_react.default.createElement("li", {
    key: placeId,
    id: "location-list-".concat(index),
    tabIndex: "0",
    role: "option",
    "aria-selected": "true",
    className: "border-bottom ".concat(0 === index && 'gray-light-bg'),
    "data-value": placeId,
    onClick: function onClick(e) {
      clickPoi(e, listToggle);
    },
    onKeyDown: onKeyDownList,
    style: {
      padding: '16px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ellipsis"
  }, /*#__PURE__*/_react.default.createElement("b", null, boldLetters), /*#__PURE__*/_react.default.createElement("span", null, remainingLetters)));
});
var LocationDropdown = function LocationDropdown(_ref5) {
  var locations = _ref5.locations,
    intl = _ref5.intl,
    props = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/_react.default.createElement(ListContainer, null, [(0, _map.default)(locations, function (data, index) {
    return /*#__PURE__*/_react.default.createElement(LocationList, _extends({
      key: data.place_id,
      data: data
    }, props, {
      index: index
    }));
  }), /*#__PURE__*/_react.default.createElement("div", {
    tabIndex: "-1",
    className: "text-center",
    style: {
      padding: '15px'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      width: 150
    },
    src: "/web-2/assets/images/powered_by_google.png?v=rb",
    alt: intl.formatMessage({
      id: 'search.location_dropdown.powered_google',
      defaultMessage: 'powered by Google'
    })
  }))]);
};
var SearchLocationDropdown = exports.SearchLocationDropdown = function SearchLocationDropdown(_ref6) {
  var whichDropdown = _ref6.whichDropdown,
    props = _objectWithoutProperties(_ref6, _excluded2);
  if (!whichDropdown) {
    return null;
  }
  var Component;
  switch (whichDropdown) {
    case 'location':
      Component = (0, _reactIntl.injectIntl)(LocationDropdown);
      break;
    case 'email':
      Component = EmailDropdown;
      break;
    case 'error':
      Component = ErrorDropdown;
  }
  return /*#__PURE__*/_react.default.createElement(Component, props);
};
ErrorDropdown.propTypes = {
  listToggle: _propTypes.default.func,
  toggleModal: _propTypes.default.func
};
EmailDropdown.propTypes = {
  metros: _propTypes.default.array,
  listToggle: _propTypes.default.func,
  toggleModal: _propTypes.default.func
};
ListContainer.propTypes = {
  children: _propTypes.default.node.isRequired
};
LocationList.propTypes = {
  data: _propTypes.default.object.isRequired,
  clickPoi: _propTypes.default.func.isRequired,
  listToggle: _propTypes.default.func,
  onKeyDownList: _propTypes.default.func,
  index: _propTypes.default.number
};
LocationDropdown.propTypes = {
  locations: _propTypes.default.object,
  intl: _propTypes.default.object
};
SearchLocationDropdown.propTypes = {
  whichDropdown: _propTypes.default.string
};